export const UPDATE_PREVIOUS_FILTER_DATE = 'UPDATE_PREVIOUS_FILTER_DATE'
export const UPDATE_FILTER_DATE = 'UPDATE_FILTER_DATE'
export const UPDATE_EMPLOYEE_UUID = 'UPDATE_EMPLOYEE_UUID'
export const RESET_EMPLOYEE_UUID = 'RESET_EMPLOYEE_UUID'
export const RESET_STATE = 'RESET_STATE'
